"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchTransaction = void 0;
var AchTransaction = /** @class */ (function () {
    function AchTransaction(transactionId, transactionType, transactionAmount, customerName, bankRoutingNumber, bankAccountNumber, bankAccountType, bankAccountBusinessType, productCode) {
        this.transactionId = transactionId;
        this.transactionType = transactionType;
        this.transactionAmount = transactionAmount;
        this.customerName = customerName;
        this.bankRoutingNumber = bankRoutingNumber;
        this.bankAccountNumber = bankAccountNumber;
        this.bankAccountType = bankAccountType;
        this.bankAccountBusinessType = bankAccountBusinessType;
        this.productCode = productCode;
    }
    return AchTransaction;
}());
exports.AchTransaction = AchTransaction;
